export default "__VITE_ASSET__ur9I6$SK__"